export const STATES_REQUEST = "STATES_REQUEST";
export const STATES_SUCCESS = "STATES_SUCCESS";
export const STATES_FAIL = "STATES_FAIL";
